import { z } from 'zod';

const TinSchema = z.string().min(5).brand('Tin');

export type Tin = z.infer<typeof TinSchema>;

export function isTin(value: string): boolean {
    return TinSchema.safeParse(value).success;
}

export function getAsTin(value: string): Tin {
    const result = TinSchema.safeParse(value);

    if (result.success) {
        return result.data;
    }

    throw new Error(`Could not parse '${value}' as Tin: ${result.error.issues.map(({ message }) => message).join(', ')}`);
}

export function parseAsTin(value: string): Tin {
    return getAsTin(value.replace(/[^a-zA-Z0-9]/g, ''));
}
